import { useState } from 'react';

import { Dehaze, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, Notifications, People, Print, Settings } from '@mui/icons-material';
import { Box, getDrawerUtilityClass } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';

import { APP_WEB_ROUTES } from '../../routes/consts/routes';
import LeftMenuItem from './components/LeftMenuItem';
import { NavMenuItem } from './components/LeftMenuItem/types/NavMenuItem';

const MENU_ITEMS: NavMenuItem[] = [
  {
    titleIcon: <Dehaze />,
    title: 'Loan Management',
    route: `${APP_WEB_ROUTES.root}${APP_WEB_ROUTES.loans}`,
  },
  {
    titleIcon: <People />,
    title: 'User Management',
    route: APP_WEB_ROUTES.users,
  },
  {
    titleIcon: <Notifications />,
    title: 'Notifications',
    route: APP_WEB_ROUTES.notifications,
  },
  {
    titleIcon: <Settings />,
    title: 'Settings',
    route: APP_WEB_ROUTES.settings,
  },
  {
    titleIcon: <Print />,
    title: 'Reports',
    route: APP_WEB_ROUTES.reports,
  },
];

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  whiteSpace: 'nowrap',
  width: open ? theme.spacing(33) : theme.spacing(10),

  [`& .${getDrawerUtilityClass('paper')}`]: {
    overflowX: 'hidden',
    paddingTop: theme.spacing(12),
    height: '100%',
    justifyContent: 'space-between',
  },

  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
  }),
}));

export default function LeftMenu() {
  const [isOpen, setIsOpen] = useState(true);

  const toggleMenu = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <Drawer variant="permanent" open={isOpen}>
      <List sx={{ p: 0 }}>
        {MENU_ITEMS.map((item) => (
          <LeftMenuItem key={item.title} title={item.title} titleIcon={item.titleIcon} isOpen={isOpen} route={item.route!} />
        ))}
      </List>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', px: 2.5, py: 1, borderTop: '1px solid #e1e1e1' }}>
        <IconButton onClick={toggleMenu}>{isOpen ? <KeyboardDoubleArrowLeft /> : <KeyboardDoubleArrowRight />}</IconButton>
      </Box>
    </Drawer>
  );
}
